import React, { useMemo } from "react";
import Typography from "@mui/material/Typography";
import { useQuery } from "@apollo/client/react";
import EntitySelect from "./EntitySelect";
import useAuth from "../hooks/useAuth";
import { PROJECTS_NAMES_QUERY } from "../constants/graphql/queries";
import { getProjectsListFromProjects } from "../utils/project";
import {
  buildDuplicateProjectNameCounts,
  getProjectClientLabel,
  getProjectOptionLabel,
} from "../utils/projectOptionLabels";

export default function FilterProjectWithAll({ onSelectProject, projectId, includeAll = true }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const { data: { projects = [] } = {} } = useQuery(PROJECTS_NAMES_QUERY, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
  });

  const projectList = getProjectsListFromProjects(projects, user, includeAll);
  const duplicateNameCounts = useMemo(
    () => buildDuplicateProjectNameCounts(projectList),
    [projectList]
  );
  const showClientNameInProjectList = Boolean(settings.display_client_name_email_notification);

  const handleChangeProject = projectItem => {
    onSelectProject({
      projectId: projectItem?.id || null,
    });
  };

  return (
    <EntitySelect
      fullWidth
      allowEmpty
      name="project"
      label={settings.filter_field2}
      value={projectId}
      suggestions={projectList}
      getOptionLabel={option =>
        getProjectOptionLabel(option, duplicateNameCounts, showClientNameInProjectList)
      }
      renderOption={(props, option) => {
        const optionProps = { ...props };
        delete optionProps.key;
        const clientLabel = getProjectClientLabel(
          option,
          duplicateNameCounts,
          showClientNameInProjectList
        );
        return (
          <li {...optionProps} key={option.id}>
            {option.name}
            {clientLabel ? (
              <Typography component="span" ml={0.5} color="text.secondary" fontSize={14}>
                {" - "}
                {clientLabel}
              </Typography>
            ) : null}
          </li>
        );
      }}
      onChange={handleChangeProject}
    />
  );
}
